<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb ">
      <li  @mouseenter="enter('/producthhmnq/productcp')" @mouseleave="leave('/producthhmnq/productcp')" class="li-padding-left20"><a @click="setroters('/producthhmnq/productcp')">
        <span :class="isproductcp==true?'font-Normal-1400':'font-Normal-14B6'">航海模拟器系列产品</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productqrw')" @mouseleave="leave('/producthhmnq/productqrw')"><a @click="setroters('/producthhmnq/productqrw')"><span
            :class="isproductqrw==true?'font-Normal-1400':'font-Normal-14B6'">全任务船舶操纵模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productytmnq')" @mouseleave="leave('/producthhmnq/productytmnq')"><a @click="setroters('/producthhmnq/productytmnq')"><span
            :class="isproductyt==true?'font-Normal-1400':'font-Normal-14B6'">游艇模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productldmnq')" @mouseleave="leave('/producthhmnq/productldmnq')"><a @click="setroters('/producthhmnq/productldmnq')"><span
            :class="isproductld==true?'font-Normal-1400':'font-Normal-14B6'">雷达模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productecdis')" @mouseleave="leave('/producthhmnq/productecdis')"><a @click="setroters('/producthhmnq/productecdis')"> <span :class="isproductecdis==true?'font-Normal-1400':'font-Normal-14B6'">ECDIS模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productgmdss')" @mouseleave="leave('/producthhmnq/productgmdss')"><a @click="setroters('/producthhmnq/productgmdss')"><span :class="isproductgmdss==true?'font-Normal-1400':'font-Normal-14B6'">GMDSS模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/producthgzymnq')" @mouseleave="leave('/producthhmnq/producthgzymnq')"><a @click="setroters('/producthhmnq/producthgzymnq')"><span :class="isproducthgzy==true?'font-Normal-1400':'font-Normal-14B6'">海工作业模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productmnq')" @mouseleave="leave('/producthhmnq/productmnq')"><a  @click="setroters('/producthhmnq/productmnq')" ><span :class="isproductmnqsj==true?'font-Normal-1400':'font-Normal-14B6'">模拟器数据编辑工具包</span></a></li>
      <li @mouseenter="enter('/producthhmnq/producthwjzyxg')" @mouseleave="leave('/producthhmnq/producthwjzyxg')"><a @click="setroters('/producthhmnq/producthwjzyxg')"><span
            :class="isproducthwjzyxg==true?'font-Normal-1400':'font-Normal-14B6'">货物积载与系固模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/producthhyqmnq')" @mouseleave="leave('/producthhmnq/producthhyqmnq')"><a @click="setroters('/producthhmnq/producthhyqmnq')"><span
            :class="isproducthhyqmnq==true?'font-Normal-1400':'font-Normal-14B6'">航海仪器模拟器</span></a></li>
      <li @mouseenter="enter('/producthhmnq/producthhjyykhpg')" @mouseleave="leave('/producthhmnq/producthhjyykhpg')"><a @click="setroters('/producthhmnq/producthhjyykhpg')"><span
            :class="isproducthhjyykhpg==true?'font-Normal-1400':'font-Normal-14B6'">航海教育与考核评估平台</span></a></li>
      <li @mouseenter="enter('/producthhmnq/productpbcbczmnq')" @mouseleave="leave('/producthhmnq/productpbcbczmnq')"><a @click="setroters('/producthhmnq/productpbcbczmnq')"><span
            :class="isproductpbcbczmnq==true?'font-Normal-1400':'font-Normal-14B6'">Pad版船舶操纵模拟器</span></a></li>                                    
      <li @mouseenter="enter('/producthhmnq/productvzhylfzxt')" @mouseleave="leave('/producthhmnq/productvzhylfzxt')"><a @click="setroters('/producthhmnq/productvzhylfzxt')"><span
            :class="isproductvzhylfzxt==true?'font-Normal-1400':'font-Normal-14B6'">VTS综合演练仿真系统</span></a></li>    
      <li @mouseenter="enter('/producthhmnq/producthsyjylfz')" @mouseleave="leave('/producthhmnq/producthsyjylfz')"><a @click="setroters('/producthhmnq/producthsyjylfz')"><span
            :class="isproducthsyjylfz==true?'font-Normal-1400':'font-Normal-14B6'">海上应急演练仿真系统</span></a></li>
     <li @mouseenter="enter('/producthhmnq/producthsltsjyl')" @mouseleave="leave('/producthhmnq/producthsltsjyl')"><a @click="setroters('/producthhmnq/producthsltsjyl')"><span
            :class="isproducthsltsjyl==true?'font-Normal-1400':'font-Normal-14B6'">海上立体搜救演练系统</span></a></li> 
     <li @mouseenter="enter('/producthhmnq/producthsxtylfz')" @mouseleave="leave('/producthhmnq/producthsxtylfz')"><a @click="setroters('/producthhmnq/producthsxtylfz')"><span
            :class="isproducthsxtylfz==true?'font-Normal-1400':'font-Normal-14B6'">海上协同演练仿真系统</span></a></li>                           
     <li @mouseenter="enter('/producthhmnq/productsjgkycbsw')" @mouseleave="leave('/producthhmnq/productsjgkycbsw')"><a @click="setroters('/producthhmnq/productsjgkycbsw')"><span
            :class="isproductsjgkycbsw==true?'font-Normal-1400':'font-Normal-14B6'">实景港口与船舶三维模型定制</span></a></li>
    </ul>   
  </div>
</template>
<script>
  export default {
    name: "producthhmnq",
    data() {
      return {
        isproductcp: false,
        isproductqrw: false,
        isproductyt: false,
        isproductld: false,
        isproductecdis: false,
        isproductgmdss: false,
        isproducthgzy: false,
        isproductmnqsj: false,
        isproducthwjzyxg: false,
        isproducthhyqmnq: false,
        isproducthhjyykhpg: false,
        isproductpbcbczmnq: false,
        isproductvzhylfzxt: false,
        isproducthsyjylfz: false,
        isproducthsltsjyl: false,
        isproducthsxtylfz: false,
        isproductsjgkycbsw: false,

        iscp: false,
        isqrw: false,
        isyt: false,
        isld: false,
        isecdis: false,
        isgmdss: false,
        ishgzy: false,
        ismnqsj: false,
        ishwjzyxg: false,
        ishhyqmnq: false,
        ishhjyykhpg: false,
        ispbcbczmnq: false,
        isvzhylfzxt: false,
        ishsyjylfz: false,
        ishsltsjyl: false,
        ishsxtylfz: false,
        issjgkycbsw: false,
      }
    },
    methods: {
           enter: function (src) {
       if (src === '/producthhmnq/productcp') {
          this.isproductcp = true
        }
        if (src === '/producthhmnq/productqrw') {
          this.isproductqrw = true
        } 
        if (src === '/producthhmnq/productytmnq') {
          this.isproductyt = true
        } 
        if (src === '/producthhmnq/productldmnq') {
          this.isproductld = true
        } 
          if (src === '/producthhmnq/productecdis') {
          this.isproductecdis = true
        }
             if (src === '/producthhmnq/productgmdss') {
          this.isproductgmdss = true
        }
            if (src === '/producthhmnq/producthgzymnq') {
          this.isproducthgzy = true
        }
              if (src === '/producthhmnq/productmnq') {
          this.isproductmnqsj = true
        }
              if (src === '/producthhmnq/producthwjzyxg') {
          this.isproducthwjzyxg = true
        }    
              if (src === '/producthhmnq/producthhyqmnq') {
          this.isproducthhyqmnq = true
        } 
              if (src === '/producthhmnq/producthhjyykhpg') {
          this.isproducthhjyykhpg = true
        }
              if (src === '/producthhmnq/productpbcbczmnq') {
          this.isproductpbcbczmnq = true
        }
              if (src === '/producthhmnq/productvzhylfzxt') {
          this.isproductvzhylfzxt = true
        }
              if (src === '/producthhmnq/producthsyjylfz') {
          this.isproducthsyjylfz = true
        }
              if (src === '/producthhmnq/producthsltsjyl') {
          this.isproducthsltsjyl = true
        }
              if (src === '/producthhmnq/producthsxtylfz') {
          this.isproducthsxtylfz = true
        }
              if (src === '/producthhmnq/productsjgkycbsw') {
          this.isproductsjgkycbsw = true
        }
      },
      leave: function (src) {
        if (src === '/producthhmnq/productcp') {
          if(this.iscp==false){
            this.isproductcp = false
          }
         
        }
        if (src === '/producthhmnq/productqrw') {
            if(this.isqrw==false){
          this.isproductqrw = false
            }
        }
        if (src === '/producthhmnq/productytmnq') {
            if(this.isyt==false){
          this.isproductyt = false
            }
        }
        if (src === '/producthhmnq/productldmnq') {
            if(this.isld==false){
          this.isproductld = false
            }
        }
          if (src === '/producthhmnq/productecdis') {
              if(this.isecdis==false){
          this.isproductecdis = false
              }
        }
             if (src === '/producthhmnq/productgmdss') {
                  if(this.isgmdss==false){
          this.isproductgmdss = false
                  }
        }
            if (src === '/producthhmnq/producthgzymnq') {
                if(this.ishgzy==false){
          this.isproducthgzy = false
                }
        }
              if (src === '/producthhmnq/productmnq') {
                  if(this.ismnqsj==false){
          this.isproductmnqsj = false
                  }
        }
              if (src === '/producthhmnq/producthwjzyxg') {
                  if(this.ishwjzyxg==false){
          this.isproducthwjzyxg = false
                  }
                  
        }     
              if (src === '/producthhmnq/producthhyqmnq') {
                  if(this.ishhyqmnq==false){
          this.isproducthhyqmnq = false
                  }
                  
        }
              if (src === '/producthhmnq/producthhjyykhpg') {
                  if(this.ishhjyykhpg==false){
          this.isproducthhjyykhpg = false
                  }
                  
        }
              if (src === '/producthhmnq/productpbcbczmnq') {
                  if(this.ispbcbczmnq==false){
          this.isproductpbcbczmnq = false
                  }       
        }
              if (src === '/producthhmnq/productvzhylfzxt') {
                  if(this.isvzhylfzxt==false){
          this.isproductvzhylfzxt = false
                  }       
        } 
              if (src === '/producthhmnq/producthsyjylfz') {
                  if(this.ishsyjylfz==false){
          this.isproducthsyjylfz = false
                  }       
        }
              if (src === '/producthhmnq/producthsltsjyl') {
                  if(this.ishsltsjyl==false){
          this.isproducthsltsjyl = false
                  }       
        }
              if (src === '/producthhmnq/producthsxtylfz') {
                  if(this.ishsxtylfz==false){
          this.isproducthsxtylfz = false
                  }       
        }
              if (src === '/producthhmnq/productsjgkycbsw') {
                  if(this.issjgkycbsw==false){
          this.isproductsjgkycbsw = false
                  }       
        }                                                                                     
      },
      setroters(src) {
        if (src === '/producthhmnq/productcp') {
          this.isproductcp = true
             this.iscp = true
          
        } else {
          this.isproductcp = false
            this.iscp = false
        }
        if (src === '/producthhmnq/productqrw') {
          this.isproductqrw = true
            this.isqrw = true
        } else {
          this.isproductqrw = false
           this.isqrw = false
        }
        if (src === '/producthhmnq/productytmnq') {
          this.isproductyt = true
            this.isyt = true
        } else {
          this.isproductyt = false
           this.isyt = false
        }
        if (src === '/producthhmnq/productldmnq') {
          this.isproductld = true
           this.isld = true
        } else {
          this.isproductld = false
           this.isld = false
        }
          if (src === '/producthhmnq/productecdis') {
          this.isproductecdis = true
          this.isecdis = true
        } else {
          this.isproductecdis = false
           this.isecdis = false
        }
             if (src === '/producthhmnq/productgmdss') {
          this.isproductgmdss = true
          this.isgmdss = true
        } else {
          this.isproductgmdss = false
           this.isgmdss = false
        }
            if (src === '/producthhmnq/producthgzymnq') {
          this.isproducthgzy = true
            this.ishgzy = true
        } else {
          this.isproducthgzy = false
           this.ishgzy = false
        }
              if (src === '/producthhmnq/productmnq') {
          this.isproductmnqsj = true
             this.ismnqsj = true
        } else {
          this.isproductmnqsj = false
          this.ismnqsj = false
        }
              if (src === '/producthhmnq/producthwjzyxg') {
          this.isproducthwjzyxg = true
             this.ishwjzyxg = true
        } else {
          this.isproducthwjzyxg = false
          this.ishwjzyxg = false
        }
              if (src === '/producthhmnq/producthhyqmnq') {
          this.isproducthhhyqmnq = true
             this.ishhyqmnq = true
        } else {
          this.isproducthhyqmnq = false
          this.ishhyqmnq = false
        }        
              if (src === '/producthhmnq/producthhjyykhpg') {
          this.isproducthhjyykhpg = true
             this.ishhjyykhpg = true
        } else {
          this.isproducthhjyykhpg = false
          this.ishhjyykhpg = false
        }
              if (src === '/producthhmnq/productpbcbczmnq') {
          this.isproductpbcbczmnq = true
             this.ispbcbczmnq = true
        } else {
          this.isproductpbcbczmnq = false
          this.ispbcbczmnq = false
        }
                if (src === '/producthhmnq/productvzhylfzxt') {
          this.isproductvzhylfzxt = true
             this.isvzhylfzxt = true
        } else {
          this.isproductvzhylfzxt = false
          this.isvzhylfzxt = false
        }
                if (src === '/producthhmnq/producthsyjylfz') {
          this.isproducthsyjylfz = true
             this.ishsyjylfz = true
        } else {
          this.isproducthsyjylfz = false
          this.ishsyjylfz = false
        }
                if (src === '/producthhmnq/producthsltsjyl') {
          this.isproducthsltsjyl = true
             this.ishsltsjyl = true
        } else {
          this.isproducthsltsjyl = false
          this.ishsltsjyl = false
        } 
                if (src === '/producthhmnq/producthsxtylfz') {
          this.isproducthsxtylfz = true
             this.ishsxtylfz = true
        } else {
          this.isproducthsxtylfz = false
          this.ishsxtylfz = false
        }
                if (src === '/producthhmnq/productsjgkycbsw') {
          this.isproductsjgkycbsw = true
             this.issjgkycbsw = true
        } else {
          this.isproductsjgkycbsw = false
          this.issjgkycbsw = false
        }                                                                             
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/producthhmnq/productcp');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb>li+li:before {
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }

  .li-height {
    line-height: 48px;
  }

  .li-padding-right16 {
    padding-right: 16px;
  }

  .li-padding-left16 {
    padding-left: 16px;
  }

  .li-padding-right20 {
    padding-right: 20px;
  }

  .li-padding-left20 {
    padding-left: 20px;
  }

.font-Normal-1400,
.font-Normal-14B6 {
  font-size: 17px; /* 固定基础字号，两个class字号保持一致 */
  font-weight: 600;
  /* 新增缩放过渡，只做视觉变化，不改变布局 */
  transition: transform 0.2s ease;
  display: inline-block; /* transform生效必备 */
  transform-origin: center; /* 居中放大，避免单侧偏移拉扯 */
}

/* 选中态只用scale放大，不改字号 */
.font-Normal-1400 {
  transform: scale(1.15); /* 视觉放大效果，替代增大font-size */
}

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/productheader.vue